import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '@lang';
import { basketSelectors } from '@store/basket/selectors';
import { BasketDrawer } from './BasketDrawer';
import { calculateTotalNumberOfItemsInBasket } from './BasketDrawer.helpers';
import { ModuleType } from './BasketListing.types';
import { useModulesToRecommend } from './hooks/useModulesToRecommend';

type BasketDrawerConnectedProps = {
  open: boolean;
  onClose: () => void;
  propertyModules: string[];
  hideArrivalTimes?: boolean;
};

export const BasketDrawerConnected: FC<BasketDrawerConnectedProps> = ({
  open,
  onClose,
  propertyModules,
  hideArrivalTimes = false,
}) => {
  const { t } = useTranslations();
  const basketDetails = useSelector(basketSelectors.getBasketDetails) as any;

  const modulesToRecommend = useModulesToRecommend({
    modules: propertyModules as ModuleType[],
    items: basketDetails?.items ?? [],
  });

  if (!open || !basketDetails) return null;

  return (
    <BasketDrawer
      open={open}
      onClose={onClose}
      currencyCode={basketDetails.total.currencyCode}
      numberOfItems={calculateTotalNumberOfItemsInBasket(basketDetails.items)}
      totalCost={basketDetails.total.amount}
      title={t('basketDrawer.title')}
      items={basketDetails.items}
      modules={modulesToRecommend}
      hideArrivalTimes={hideArrivalTimes}
    />
  );
};
